import { createContext } from 'react';
import { SCHEDULE as STATIC_SCHEDULE } from '../data/schedule';

// React Context lives in its own file so the provider component (in
// ScheduleContext.jsx) and the consumer hook (in useSchedule.js) can each
// be a Fast-Refresh-friendly single-purpose module.
export const ScheduleContext = createContext({
  schedule: STATIC_SCHEDULE,
  loading: true,
  source: 'static',
});
